import React from "react";
import { useSite } from "@/context/SiteContext";
import { useEnquiry } from "@/context/EnquiryContext";
import { track } from "@/lib/track";
import { WhatsAppIcon } from "@/components/BrandIcons";
import { Phone, ArrowRight } from "lucide-react";

export default function MobileBar() {
  const site = useSite();
  const { open } = useEnquiry();
  const s = (site && site.site) || {};
  const wa = (s.whatsapp_number || "919924405739").replace(/[^\d]/g, "");
  const phone = ((s.header_phone && s.header_phone.number) || s.primary_phone || "+919924405739").replace(/[^\d+]/g, "");
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 grid grid-cols-3 sm:hidden bg-white/95 backdrop-blur border-t" style={{ borderColor: "var(--border-c)" }} data-testid="mobile-action-bar">
      <a href={`tel:${phone}`} onClick={() => track("phone_click")} className="flex flex-col items-center gap-0.5 py-2.5 text-xs font-semibold" style={{ color: "var(--brand-primary)" }} data-testid="mobile-call"><Phone size={18} /> Call</a>
      <a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" onClick={() => track("whatsapp_click")} className="flex flex-col items-center gap-0.5 py-2.5 text-xs font-semibold border-x" style={{ color: "#25D366", borderColor: "var(--border-c)" }} data-testid="mobile-whatsapp"><WhatsAppIcon size={18} /> WhatsApp</a>
      <button onClick={() => open({})} className="flex flex-col items-center gap-0.5 py-2.5 text-xs font-semibold text-white" style={{ background: "var(--brand-primary)" }} data-testid="mobile-get-quote"><ArrowRight size={18} /> Get Quote</button>
    </div>
  );
}
